import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class PopupWindowService {

  constructor() { }

  getNativeWindow() {
    return window;
  }
}
